import styled from 'styled-components';
import circle from '~/assets/icons/switch-circle.svg';
import circleWhite from '~/assets/icons/switch-circle-white.svg';

export const Container = styled.div`
  background-color: #f6f6f6;
  border-radius: 8px;

  .form-switch .form-check-input:focus {
    background-image: url(${circle});
  }
  .form-check-input:checked {
    background-color: #ff6900;
    border-color: #ff6900;
    background-image: url(${circleWhite}) !important;
  }
  .form-check-input {
    width: 3rem;
    height: 1.5rem;
    background-color: transparent;
    border-color: #d3d3d3;
  }

  .btn-title {
    color: #b9612f;
  }

  .bg-white {
    border-radius: 8px;
  }

  .btn-add-aswer {
    color: #777;
  }

  .checkbox label {
    border: none !important;
    padding: 0px !important;
    span {
      border: none !important;
      color: #202020;
    }
  }

  .answers {
    border: 1px solid #c8c8c8;
  }

  .input input::placeholder {
    color: #d4d4d4;
  }

  .grab {
    cursor: grab;
  }

  .grab:active {
    cursor: grabbing;
  }

  .hr-question {
    background: #e9b89c;
    opacity: 1;
    height: 1px;
    margin: 0 10px;
    flex: 1;
  }
`;
